
    const original = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"16.1939\" height=\"14.81554\" viewBox=\"0,0,16.1939,14.81554\"><g transform=\"translate(-231.6316,-173.46723)\"><g fill=\"#855cd6\" stroke=\"#855cd6\" stroke-miterlimit=\"10\"><path d=\"M232.1316,178.39474h8.78613v-3.7204l6.20066,6.20066l-6.20066,6.20066v-3.7204h-8.78613z\"/></g></g></svg><!--rotationCenter:8.36839754687503:6.532769068753481-->";

    const getSRC = () => {
        const recolored = typeof Recolor === 'object' ? (
            original.replace(/#855cd6/gi, Recolor.primary)
        ) : original;
        return 'data:image/svg+xml;,' + encodeURIComponent(recolored);
    };

    export default getSRC;
